<template>
   <div>
      <div class="row p-2 mt-4">
         <div class="col-12">
            <span class="custom-span-lg" style="color: #435666;">Configuration
               <i class="fa-solid fa-arrow-right"></i>
            </span>
            <span class="custom-span-no-weight" style="color: #435666;"> &nbsp;Government TLDs</span>
            <div class="mt-2">
               <small class="text-muted">
                  <i class="fa-solid fa-circle-info me-1" style="color: #00A0C1;"></i>
                  Manage access to government top-level domains. <strong>Allow</strong>, <strong>Off</strong>, or <strong>Block</strong> each TLD individually. This module will only work for Extension Version 3.1.0 and above on Chrome, and 2.1.0 and above on Firefox. <strong>Please note:</strong> It may take up to 30 minutes for this change to be reflected in your browser. Page refresh is required.
               </small>
            </div>
         </div>
      </div>

      <GovernmentTlds />
   </div>
</template>

<script>
import GovernmentTlds from '@/components/ExtensionConfiguration/GovernmentTlds/GovernmentTlds.vue';

export default {

   components: {
      GovernmentTlds,
   },

}
</script>

<style scoped>
.custom-span-lg {
   font-size: 24px;
   line-height: 24px;
   font-weight: bold;
}

.custom-span-no-weight {
   font-size: 24px;
   line-height: 24px;
   font-weight: 250;
}
</style>